export default __webpack_public_path__ + "static/media/ipfs.c791d344.gif";